import {Component, inject, Input} from '@angular/core';
import {FilterGroupHierarchyNode} from '../../../../core/definitions/search-objects';
import {SearchExecutorService} from '../../../search-executor.service';
import {SearchContainer} from '../../../../core/definitions/search-container';
import {FeatureFlagsService} from "../../../../core/feature-flags.service";

@Component({
    selector: 'app-search-filter-hierarchy',
    templateUrl: './search-filter-hierarchy.component.html',
    styleUrls: ['./search-filter-hierarchy.component.scss'],
    standalone: false
})
export class SearchFilterHierarchyComponent {
  // Injections
  private readonly featureFlags: FeatureFlagsService = inject(FeatureFlagsService);
  private readonly searchExecutorService: SearchExecutorService = inject(SearchExecutorService);

  @Input() sideMenu;
  @Input() node: FilterGroupHierarchyNode;
  @Input() searchContainer: SearchContainer;
  @Input() nodeQuery: string;

  toggleOpen(node: FilterGroupHierarchyNode) {
    if (node.children && Object.keys(node.children).length) {
      node.open = !node.open;
    }
  }

  select(node: FilterGroupHierarchyNode) {
    const lastSelectedNode = this.searchContainer.filtersFacets.hierarchicFilterGroup.lastSelectedNode;
    if (!lastSelectedNode || lastSelectedNode.facet.id !== node.facet.id) {
      if (lastSelectedNode) {
        lastSelectedNode.facet.selected = false;
      }
      this.searchContainer.filtersFacets.hierarchicFilterGroup.lastSelectedNode = node;
      node.facet.selected = true;
    } else {
      lastSelectedNode.facet.selected = false;
      this.searchContainer.filtersFacets.hierarchicFilterGroup.lastSelectedNode = null;
    }
    this.searchExecutorService.runSearch(this.searchContainer).then();
  }

  getChildNodes() {
    if (!this.nodeQuery) {
      return this.node.childrenArray
    } else {
      return this.node.childrenArray.filter(
        child => child.facet.shortName.toLowerCase().indexOf(this.nodeQuery.toLowerCase()) !== -1);
    }
  }

  protected readonly newFilterMenu = this.featureFlags.getFeatureFlags()?.experimental?.useNewFilterMenu;
}
